// removed by extract-text-webpack-plugin
module.exports = {"collapse":"_326wghBv"};


//////////////////
// WEBPACK FOOTER
// ./app/profile/components/profile-dialog/profile-dialog.component.scss
// module id = 721
// module chunks = 0